import { render, staticRenderFns } from "./ProjectsTickets.vue?vue&type=template&id=aeb7dc62&"
import script from "./ProjectsTickets.vue?vue&type=script&lang=js&"
export * from "./ProjectsTickets.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsTickets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VCard,VWindow,VWindowItem})
